import type { FC } from 'react';

import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

export const AvatarIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 22 22" fill="none">
      <circle cx="11" cy="11" r="10.5" fill="#0DD3FF" />
      <circle cx="11" cy="11" r="10.5" fill="#858EC6" />
      <path
        d="M21.5 11C21.5 16.799 16.799 21.5 11 21.5C5.20101 21.5 0.5 16.799 0.5 11C0.5 5.201 5.20101 11 11 11C16.799 11 21.5 5.201 21.5 11Z"
        fill="#0DD3FF"
      />
      <path
        d="M21.5 11C21.5 16.799 16.799 21.5 11 21.5C5.20101 21.5 0.5 16.799 0.5 11C0.5 5.201 5.20101 11 11 11C16.799 11 21.5 5.201 21.5 11Z"
        fill="#320A8D"
      />
    </SvgIcon>
  );
};

export const PowerIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24" fill="none">
      <path
        fill="currentColor"
        d="M13.5 3H11.5V13H13.5V3ZM18.33 5.17L16.91 6.59C18.49 7.86 19.5 9.81 19.5 12C19.5 15.87 16.37 19 12.5 19C8.63 19 5.5 15.87 5.5 12C5.5 9.81 6.51 7.86 8.08 6.58L6.67 5.17C4.73 6.82 3.5 9.26 3.5 12C3.5 16.97 7.53 21 12.5 21C17.47 21 21.5 16.97 21.5 12C21.5 9.26 20.27 6.82 18.33 5.17Z"
      />
    </SvgIcon>
  );
};

export const ArrowDownIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 25 24" fill="none">
      <path d="M7.5 9.5L12.5 14.5L17.5 9.5H7.5Z" fill="currentColor" />
    </SvgIcon>
  );
};

export const ChevronIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24" fill="none">
      <path
        fill="currentColor"
        d="M16.59 8.295L12 12.875L7.41 8.295L6 9.705L12 15.705L18 9.705L16.59 8.295Z"
      />
    </SvgIcon>
  );
};

export const OpenInNewIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 16 16" fill="none">
      <path
        d="M10 2H14M14 2V6M14 2L6.66667 9.33333M12 8.66667V12.6667C12 13.0203 11.8595 13.3594 11.6095 13.6095C11.3594 13.8595 11.0203 14 10.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V5.33333C2 4.97971 2.14048 4.64057 2.39052 4.39052C2.64057 4.14048 2.97971 4 3.33333 4H7.33333"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const CopyIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20" fill="none">
      <g clipPath="url(#clip0_1586_816)">
        <path
          d="M3.33317 13.3332C2.4165 13.3332 1.6665 12.5832 1.6665 11.6665V3.33317C1.6665 2.4165 2.4165 1.6665 3.33317 1.6665H11.6665C12.5832 1.6665 13.3332 2.4165 13.3332 3.33317M8.33317 6.6665H16.6665C17.587 6.6665 18.3332 7.4127 18.3332 8.33317V16.6665C18.3332 17.587 17.587 18.3332 16.6665 18.3332H8.33317C7.4127 18.3332 6.6665 17.587 6.6665 16.6665V8.33317C6.6665 7.4127 7.4127 6.6665 8.33317 6.6665Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
};

export const ApiKeyIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24" fill="none">
      <path
        d="M21 10H12.65C11.83 7.67 9.61 6 7 6C3.69 6 1 8.69 1 12C1 15.31 3.69 18 7 18C9.61 18 11.83 16.33 12.65 14H13L15 16L17 14L19 16L23 11.96L21 10ZM7 15C5.35 15 4 13.65 4 12C4 10.35 5.35 9 7 9C8.65 9 10 10.35 10 12C10 13.65 8.65 15 7 15Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export const EditIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24" fill="none">
      <path
        d="M2.99902 17.2515V21.0015H6.74902L17.809 9.94152L14.059 6.19152L2.99902 17.2515ZM20.709 7.04152C21.099 6.65152 21.099 6.02152 20.709 5.63152L18.369 3.29152C17.979 2.90152 17.349 2.90152 16.959 3.29152L15.129 5.12152L18.879 8.87152L20.709 7.04152Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export const DeleteIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24" fill="none">
      <path
        d="M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM19 4H15.5L14.5 3H9.5L8.5 4H5V6H19V4Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export const CloseIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 34 34" fill="none">
      <path
        fill="currentColor"
        d="M26.7228 9.23568L24.7644 7.27734L17.0005 15.0412L9.23665 7.27734L7.27832 9.23568L15.0422 16.9996L7.27832 24.7635L9.23665 26.7218L17.0005 18.9579L24.7644 26.7218L26.7228 24.7635L18.9589 16.9996L26.7228 9.23568Z"
      />
    </SvgIcon>
  );
};

export const SuccessIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 34 34" fill="none">
      <path
        fill="currentColor"
        d="M12.5486 22.3822L6.75689 16.5905L4.78467 18.5489L12.5486 26.3127L29.2152 9.64608L27.2569 7.68774L12.5486 22.3822Z"
      />
    </SvgIcon>
  );
};

export const FilterIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24" fill="none">
      <path
        d="M12 5H2M6 12H18M9 19H15M16 5H22M19 8V2"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const ArrowLeftIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24" fill="none">
      <path
        d="M12 19L5 12M5 12L12 5M5 12H19"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const TableViewIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 18 18" fill="none">
      <path
        d="M14.6756 14.6754C13.6602 15.6907 12.0261 15.6907 8.75778 15.6907C5.48947 15.6907 3.85531 15.6907 2.83998 14.6754C1.82464 13.6601 1.82464 12.0259 1.82464 8.7576C1.82464 5.48929 1.82464 3.85513 2.83998 2.8398C3.85531 1.82446 5.48947 1.82446 8.75778 1.82446C12.0261 1.82446 13.6602 1.82446 14.6756 2.8398C15.6909 3.85513 15.6909 5.48929 15.6909 8.7576C15.6909 12.0259 15.6909 13.6601 14.6756 14.6754Z"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6909 6.20337L1.82464 6.20337"
        stroke="currentColor"
        strokeWidth="1"
      />
      <path
        d="M15.6909 11.312L1.82464 11.312"
        stroke="currentColor"
        strokeWidth="1"
      />
    </SvgIcon>
  );
};

export const GridViewIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 18 18" fill="none">
      <path
        d="M14.6767 2.84012C15.6921 3.85554 15.6921 5.48982 15.6921 8.75839C15.6921 12.027 15.6921 13.6612 14.6767 14.6767C13.6612 15.6921 12.027 15.6921 8.75839 15.6921C5.48982 15.6921 3.85553 15.6921 2.84012 14.6767C1.82471 13.6612 1.82471 12.027 1.82471 8.75839C1.82471 5.48982 1.82471 3.85553 2.84012 2.84012C3.85554 1.82471 5.48982 1.82471 8.75839 1.82471C12.027 1.82471 13.6612 1.82471 14.6767 2.84012Z"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6919 8.7583L1.82453 8.7583"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
      />
      <path
        d="M8.7583 1.82471L8.7583 15.6921"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
};

export const LinkIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_890_8119)" fill="none">
        <path
          d="M6.6668 8.66795C6.9531 9.0507 7.31837 9.3674 7.73783 9.59657C8.1573 9.82574 8.62114 9.96202 9.0979 9.99617C9.57466 10.0303 10.0532 9.96152 10.501 9.79447C10.9489 9.62741 11.3555 9.36599 11.6935 9.02795L13.6935 7.02795C14.3007 6.39927 14.6366 5.55726 14.629 4.68328C14.6215 3.80929 14.2709 2.97324 13.6529 2.35522C13.0348 1.73719 12.1988 1.38663 11.3248 1.37903C10.4508 1.37144 9.60881 1.70742 8.98013 2.31461L7.83347 3.45461M9.33347 7.33461C9.04716 6.95186 8.68189 6.63516 8.26243 6.40599C7.84297 6.17681 7.37913 6.04054 6.90237 6.00639C6.4256 5.97225 5.94708 6.04103 5.49924 6.20809C5.0514 6.37515 4.64472 6.63657 4.3068 6.97461L2.3068 8.97461C1.69961 9.60329 1.36363 10.4453 1.37122 11.3193C1.37881 12.1933 1.72938 13.0293 2.3474 13.6473C2.96543 14.2654 3.80147 14.6159 4.67546 14.6235C5.54945 14.6311 6.39146 14.2951 7.02013 13.6879L8.16013 12.5479"
          stroke="currentColor"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
};

export const ConnectWalletIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 18 18" fill="none">
      <path
        d="M12.6347 10.9572L14.5919 9C16.136 7.45584 16.136 4.95227 14.5919 3.40812C13.0477 1.86396 10.5442 1.86396 9 3.40812L7.04284 5.36528M10.9572 12.6347L9 14.5919C7.45584 16.136 4.95227 16.136 3.40812 14.5919C1.86396 13.0477 1.86396 10.5442 3.40812 9L5.36528 7.04284"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
      />
      <path
        d="M16.5 12.75H14.9408M12.75 16.5L12.75 14.9408"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 5.25H3.05917M5.25 1.5L5.25 3.05917"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const MobileBottomNavDashboardIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 36 35" fill="none">
      <path
        d="M15 25C17.2091 25 19 26.7909 19 29V31C19 33.2091 17.2091 35 15 35H8C5.79086 35 4 33.2091 4 31V29C4 26.7909 5.79086 25 8 25H15ZM32 17C34.2091 17 36 18.7909 36 21V31C36 33.2091 34.2091 35 32 35H25C22.7909 35 21 33.2091 21 31V21C21 18.7909 22.7909 17 25 17H32ZM15 5C17.2091 5 19 6.79086 19 9V19C19 21.2091 17.2091 23 15 23H8C5.79086 23 4 21.2091 4 19V9C4 6.79086 5.79086 5 8 5H15ZM32 5C34.2091 5 36 6.79086 36 9V11C36 13.2091 34.2091 15 32 15H25C22.7909 15 21 13.2091 21 11V9C21 6.79086 22.7909 5 25 5H32Z"
        fillOpacity="0.1"
      />
      <rect
        x="0.5"
        y="0.5"
        width="14"
        height="17"
        rx="3.5"
        stroke="currentColor"
      />
      <rect
        x="0.5"
        y="20.5"
        width="14"
        height="9"
        rx="3.5"
        stroke="currentColor"
      />
      <rect
        x="31.5"
        y="29.5"
        width="14"
        height="17"
        rx="3.5"
        transform="rotate(-180 31.5 29.5)"
        stroke="currentColor"
      />
      <rect
        x="31.5"
        y="9.5"
        width="14"
        height="9"
        rx="3.5"
        transform="rotate(-180 31.5 9.5)"
        stroke="currentColor"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1154_3379"
          x1="8"
          y1="6.5"
          x2="20"
          y2="35"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0.13" />
        </linearGradient>
      </defs>
    </SvgIcon>
  );
};

export const MobileBottomNavCampaignsIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 36 36" fill="none">
      <g clipPath="url(#clip0_2502_11391)">
        <path
          d="M19.1759 9.23877L12.9289 18.3768C12.4481 19.0801 11.7836 19.5704 10.9655 19.8263C10.43 19.9939 10.1623 20.0776 9.95877 20.166C7.4319 21.264 7.03757 23.9933 8.2832 26.1508L8.9668 27.3348C10.2124 29.4923 12.7732 30.5154 14.9875 28.8761C15.1658 28.7441 15.3723 28.5541 15.7851 28.1741C16.4158 27.5936 17.1727 27.2632 18.0221 27.1985L29.0594 26.3574C31.5931 26.1643 32.8599 26.0678 33.7516 25.0581C34.6432 24.0485 34.563 23.033 34.4027 21.0019C33.9622 15.4245 31.0955 10.4592 26.4856 7.28913C24.8068 6.1347 23.9674 5.55748 22.6472 5.82485C21.327 6.09223 20.61 7.14108 19.1759 9.23877Z"
          fill="url(#paint0_linear_2502_11391)"
        />
        <path
          d="M16.1095 5.94697L9.86249 15.085C9.38169 15.7883 8.7172 16.2785 7.89904 16.5345C7.36361 16.702 7.09586 16.7858 6.89237 16.8742C4.3655 17.9722 3.97116 20.7015 5.21679 22.859L5.90039 24.043C7.14603 26.2005 9.70682 27.2236 11.9211 25.5843C12.0994 25.4523 12.3059 25.2622 12.7186 24.8823C13.3494 24.3018 14.1063 23.9714 14.9557 23.9067L25.993 23.0656C28.5267 22.8725 29.7935 22.776 30.6852 21.7663C31.5768 20.7567 31.4966 19.7411 31.3362 17.7101C30.8958 12.1327 28.0291 7.16741 23.4192 3.99733C21.7404 2.84289 20.901 2.26567 19.5808 2.53304C18.2606 2.80042 17.5436 3.84927 16.1095 5.94697Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.4838 31.1662L21.7177 31.4354C23.63 31.6658 24.5861 31.781 25.1661 31.5124C25.9395 31.1543 26.4441 30.39 26.4697 29.5381C26.4888 28.8992 26.0073 28.0652 25.0442 26.3971L24.6692 25.7476L15 27L16.125 28.9486C17.0414 30.5358 17.6643 30.947 19.4838 31.1662Z"
          fill="url(#paint1_linear_2502_11391)"
        />
        <path
          d="M23.0489 23.7452L23.4239 24.3947C24.3869 26.0628 24.8685 26.8968 24.8493 27.5357C24.8238 28.3876 24.3191 29.1519 23.5458 29.51C22.9658 29.7786 22.0096 29.6634 20.0973 29.433L17.8635 29.1638C16.0439 28.9446 15.421 28.5334 14.5046 26.9461L13.3796 24.9976"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.6543 23.9731L9.1543 16.1789"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2502_11391"
          x1="14.6913"
          y1="10.25"
          x2="25.9413"
          y2="29.7356"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" stopOpacity="0.13" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0.13" />
        </linearGradient>
      </defs>
    </SvgIcon>
  );
};

export const WarningIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20" fill="none">
      <path
        d="M4.43411 8.06683C6.4455 4.50771 7.4512 2.72815 8.83123 2.27006C9.59044 2.01805 10.4083 2.01805 11.1675 2.27006C12.5475 2.72815 13.5532 4.50771 15.5646 8.06683C17.576 11.6259 18.5817 13.4055 18.28 14.8555C18.114 15.6532 17.7051 16.3768 17.1119 16.9225C16.0335 17.9144 14.0221 17.9144 9.99935 17.9144C5.97655 17.9144 3.96516 17.9144 2.88682 16.9225C2.29358 16.3768 1.88467 15.6532 1.7187 14.8555C1.41701 13.4055 2.42271 11.6259 4.43411 8.06683Z"
        fill="none"
        stroke="currentColor"
        strokeOpacity="0.85"
        strokeWidth="1.6625"
      />
      <path
        d="M10.2005 14.1662V10.8328C10.2005 10.44 10.2005 10.2436 10.0785 10.1216C9.95644 9.99951 9.76002 9.99951 9.36719 9.99951"
        fill="none"
        stroke="currentColor"
        strokeOpacity="0.85"
        strokeWidth="1.6625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99203 7.49951H9.99951"
        fill="none"
        stroke="currentColor"
        strokeOpacity="0.85"
        strokeWidth="1.6625"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const RefreshIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 16 16" fill="none">
      <path
        d="M14 8C14 9.18669 13.6481 10.3467 12.9888 11.3334C12.3295 12.3201 11.3925 13.0892 10.2961 13.5433C9.19975 13.9974 7.99335 14.1162 6.82946 13.8847C5.66558 13.6532 4.59648 13.0818 3.75736 12.2426C2.91825 11.4035 2.3468 10.3344 2.11529 9.17054C1.88378 8.00666 2.0026 6.80026 2.45673 5.7039C2.91085 4.60754 3.67989 3.67047 4.66658 3.01118C5.65328 2.35189 6.81331 2 8 2C9.68 2 11.2867 2.66667 12.4933 3.82667L14 5.33333M14 5.33333V2M14 5.33333H10.6667"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const NoKeysIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 47 47" fill="none">
      <circle
        cx="22.8478"
        cy="23.7223"
        r="16.8146"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
      />
      <rect
        x="33.5312"
        y="10.46"
        width="2.87378"
        height="32.6271"
        transform="rotate(45 33.5312 10.46)"
        fill="currentColor"
      />
      <rect
        x="10.4092"
        y="12.6621"
        width="2.87756"
        height="32.6271"
        transform="rotate(-45 10.4092 12.6621)"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export const CancelIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 32 32" fill="none">
      <path
        d="M20.0003 11.9998L12.0003 19.9998M12.0003 11.9998L20.0003 19.9998M29.3337 15.9998C29.3337 23.3636 23.3641 29.3332 16.0003 29.3332C8.63653 29.3332 2.66699 23.3636 2.66699 15.9998C2.66699 8.63604 8.63653 2.6665 16.0003 2.6665C23.3641 2.6665 29.3337 8.63604 29.3337 15.9998Z"
        fill="none"
        stroke="#FB4A4A"
        strokeWidth="2.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const CampaignIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 52 52" fill="none">
      <path
        d="M5.41602 25.9998C5.41602 16.2968 5.41602 11.4452 8.43038 8.43086C11.4447 5.4165 16.2963 5.4165 25.9993 5.4165C35.7024 5.4165 40.554 5.4165 43.5683 8.43086C46.5827 11.4452 46.5827 16.2968 46.5827 25.9998C46.5827 35.7029 46.5827 40.5545 43.5683 43.5688C40.554 46.5832 35.7024 46.5832 25.9993 46.5832C16.2963 46.5832 11.4447 46.5832 8.43038 43.5688C5.41602 40.5545 5.41602 35.7029 5.41602 25.9998Z"
        fill="none"
        stroke="#D4CFFF"
        strokeWidth="3.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.5827 29.25H35.9104C34.0858 29.25 32.6523 30.7744 31.8482 32.3857C30.9746 34.1361 29.2252 35.75 25.9993 35.75C22.7735 35.75 21.0241 34.1361 20.1505 32.3857C19.3464 30.7744 17.9129 29.25 16.0883 29.25H5.41602"
        fill="none"
        stroke="#D4CFFF"
        strokeWidth="3.25"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const BigFilterIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 52 52" fill="none">
      <path
        d="M45.4971 9.75C45.4717 8.80759 45.2738 8.1325 44.7894 7.59937C43.7907 6.5 42.0246 6.5 38.4923 6.5H13.5077C9.97542 6.5 8.20928 6.5 7.21057 7.59937C6.21185 8.69874 6.43091 10.4017 6.86904 13.8077C6.99699 14.8024 7.20979 15.3671 7.85923 16.1388C9.95721 18.6315 13.7995 23.0655 19.1912 27.0965C19.6839 27.4648 20.0072 28.0669 20.0618 28.733C20.6691 36.1538 21.2256 41.2233 21.521 43.7186C21.676 45.0276 23.1271 46.0344 24.323 45.1888C26.3319 43.7679 30.0847 42.1757 30.5806 39.5291C30.7636 38.5524 31.0128 37.0073 31.2975 34.6667"
        fill="none"
        stroke="#D4CFFF"
        strokeWidth="3.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.5 15.1665L32.5 28.1665M45.5 28.1665L32.5 15.1665"
        fill="none"
        stroke="#D4CFFF"
        strokeWidth="3.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const LockIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 52 52" fill="none">
      <path
        d="M38.9997 23.8423C37.7356 21.4869 35.2578 19.8418 32.3955 19.7151C29.1999 19.5738 25.9538 19.5 22.3791 19.5C18.8044 19.5 15.5583 19.5738 12.3628 19.7151C8.56511 19.8832 5.4444 22.7242 4.93713 26.3505C4.60606 28.7171 4.33301 31.1424 4.33301 33.6123C4.33301 36.0823 4.60606 38.5076 4.93713 40.8742C5.4444 44.5005 8.56512 47.3415 12.3628 47.5096C13.9099 47.578 15.7306 47.6306 17.333 47.6667"
        fill="none"
        stroke="#D4CFFF"
        strokeWidth="3.25"
        strokeLinecap="round"
      />
      <path
        d="M13 19.5002V14.0835C13 8.69872 17.3652 4.3335 22.75 4.3335C28.1348 4.3335 32.5 8.69872 32.5 14.0835V19.5002"
        fill="none"
        stroke="#D4CFFF"
        strokeWidth="3.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.9429 32.7267L44.6854 34.0074V34.0074L45.9429 32.7267ZM46.4088 35.6996C47.1161 36.3941 48.2525 36.3837 48.9471 35.6764C49.6416 34.9691 49.6312 33.8327 48.9239 33.1382L47.6663 34.4189L46.4088 35.6996ZM39.0492 32.7267L37.7916 31.446V31.446L39.0492 32.7267ZM39.5151 39.0841C40.2224 39.7786 41.3588 39.7682 42.0533 39.0609C42.7478 38.3536 42.7374 37.2172 42.0301 36.5226L40.7726 37.8034L39.5151 39.0841ZM32.1545 46.2649L30.897 44.9842C29.6915 46.1679 27.7237 46.1679 26.5183 44.9842L25.2608 46.2649L24.0032 47.5457C26.6051 50.1004 30.8102 50.1004 33.412 47.5457L32.1545 46.2649ZM25.2608 46.2649L26.5183 44.9842C25.3311 43.8185 25.3311 41.9424 26.5183 40.7767L25.2608 39.496L24.0032 38.2153C21.3831 40.788 21.3831 44.973 24.0032 47.5457L25.2608 46.2649ZM25.2608 39.496L26.5183 40.7767C27.7237 39.5931 29.6915 39.5931 30.897 40.7767L32.1545 39.496L33.412 38.2153C30.8102 35.6606 26.6051 35.6606 24.0032 38.2153L25.2608 39.496ZM32.1545 39.496L30.897 40.7767C32.0842 41.9424 32.0842 43.8185 30.897 44.9842L32.1545 46.2649L33.412 47.5457C36.0322 44.973 36.0322 40.788 33.412 38.2153L32.1545 39.496ZM45.9429 32.7267L44.6854 34.0074L46.4088 35.6996L47.6663 34.4189L48.9239 33.1382L47.2004 31.446L45.9429 32.7267ZM32.1545 39.496L33.412 40.7768L38.5832 35.6997L37.3257 34.4189L36.0683 33.1381L30.897 38.2153L32.1545 39.496ZM37.3257 34.4189L38.5832 35.6996L40.3067 34.0074L39.0492 32.7267L37.7916 31.446L36.0682 33.1382L37.3257 34.4189ZM37.3257 34.4189L36.0682 35.6996L39.5151 39.0841L40.7726 37.8034L42.0301 36.5226L38.5832 33.1382L37.3257 34.4189ZM45.9429 32.7267L47.2004 31.446C46.424 30.6836 45.716 29.9831 45.0649 29.4953C44.3711 28.9755 43.541 28.5386 42.496 28.5386V30.3335V32.1284C42.4979 32.1284 42.5076 32.126 42.5519 32.1441C42.61 32.1679 42.7228 32.2261 42.9126 32.3683C43.3263 32.6782 43.837 33.1743 44.6854 34.0074L45.9429 32.7267ZM39.0492 32.7267L40.3067 34.0074C41.1551 33.1743 41.6658 32.6782 42.0795 32.3683C42.2693 32.2261 42.3821 32.1679 42.4402 32.1441C42.4845 32.126 42.4942 32.1284 42.496 32.1284V30.3335V28.5386C41.451 28.5386 40.621 28.9755 39.9272 29.4953C39.2761 29.9831 38.5681 30.6836 37.7916 31.446L39.0492 32.7267Z"
        fill="#D4CFFF"
      />
    </SvgIcon>
  );
};

export const SettingsIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 52 52" fill="none">
      <path
        d="M30.8651 21.0675C31.3838 21.7999 32.398 21.973 33.1304 21.4542C33.8627 20.9355 34.0359 19.9213 33.5171 19.1889L32.1911 20.1282L30.8651 21.0675ZM19.7603 31.2799C20.4203 31.888 21.4484 31.846 22.0565 31.186C22.6647 30.526 22.6226 29.4979 21.9626 28.8898L20.8615 30.0848L19.7603 31.2799ZM34.9363 4.97381L35.7347 3.55844V3.55844L34.9363 4.97381ZM38.6731 7.08161L37.8748 8.49697V8.49697L38.6731 7.08161ZM17.0611 43.7762L17.8594 42.3609H17.8594L17.0611 43.7762ZM13.3242 41.6684L14.1226 40.253H14.1226L13.3242 41.6684ZM13.3277 7.0814L12.5293 5.66603V5.66603L13.3277 7.0814ZM17.0645 4.9736L16.2662 3.55823V3.55823L17.0645 4.9736ZM12.2582 10.1701L10.686 10.581V10.581L12.2582 10.1701ZM6.47491 19.8624L6.05445 18.2927L6.05444 18.2927L6.47491 19.8624ZM6.4749 28.8877L6.05436 30.4573H6.05436L6.4749 28.8877ZM12.2549 38.5798L13.8271 38.9909V38.9909L12.2549 38.5798ZM20.2231 5.60215L19.0792 6.75632V6.75632L20.2231 5.60215ZM31.7777 5.60235L32.9216 6.75653V6.75653L31.7777 5.60235ZM39.7425 10.1703L41.3146 10.5814V10.5814L39.7425 10.1703ZM45.5225 19.8624L45.943 18.2927V18.2927L45.5225 19.8624ZM11.9517 8.11307L10.4566 7.47646V7.47646L11.9517 8.11307ZM18.6329 44.4102L18.4172 42.7995L18.4172 42.7995L18.6329 44.4102ZM20.2196 43.1476L19.0755 41.9935L19.0755 41.9936L20.2196 43.1476ZM4.55538 20.6064L3.26854 19.6141L3.26854 19.6141L4.55538 20.6064ZM46.0404 22.7705C46.0404 23.668 46.7679 24.3955 47.6654 24.3955C48.5628 24.3955 49.2904 23.668 49.2904 22.7705H47.6654H46.0404ZM21.7909 43.9144C22.4824 43.3424 22.5792 42.318 22.0071 41.6265C21.435 40.935 20.4107 40.8382 19.7192 41.4103L20.7551 42.6624L21.7909 43.9144ZM18.4154 24.5066H20.0404C20.0404 21.2159 22.708 18.5483 25.9987 18.5483V16.9233V15.2983C20.9131 15.2983 16.7904 19.421 16.7904 24.5066H18.4154ZM25.9987 16.9233V18.5483C28.0066 18.5483 29.783 19.54 30.8651 21.0675L32.1911 20.1282L33.5171 19.1889C31.8519 16.8381 29.1052 15.2983 25.9987 15.2983V16.9233ZM20.8615 30.0848L21.9626 28.8898C20.7785 27.7988 20.0404 26.2401 20.0404 24.5066H18.4154H16.7904C16.7904 27.1857 17.9365 29.5994 19.7603 31.2799L20.8615 30.0848ZM4.33203 26.4561H5.95703V22.2939H4.33203H2.70703V26.4561H4.33203ZM34.9363 4.97381L34.138 6.38917L37.8748 8.49697L38.6731 7.08161L39.4715 5.66624L35.7347 3.55844L34.9363 4.97381ZM17.0611 43.7762L17.8594 42.3609L14.1226 40.253L13.3242 41.6684L12.5259 43.0838L16.2627 45.1916L17.0611 43.7762ZM13.3277 7.0814L14.126 8.49677L17.8629 6.38897L17.0645 4.9736L16.2662 3.55823L12.5293 5.66603L13.3277 7.0814ZM12.2582 10.1701L10.686 10.581C11.5404 13.85 9.45558 17.3817 6.05445 18.2927L6.47491 19.8624L6.89537 21.4321C11.9473 20.0788 15.1563 14.832 13.8304 9.75919L12.2582 10.1701ZM6.4749 28.8877L6.05436 30.4573C9.45422 31.3682 11.5377 34.8993 10.6828 38.1687L12.2549 38.5798L13.8271 38.9909C15.1534 33.9187 11.9472 28.6715 6.89545 27.318L6.4749 28.8877ZM20.2231 5.60215L19.0792 6.75632C22.8743 10.5176 29.1265 10.5178 32.9216 6.75653L31.7777 5.60235L30.6338 4.44816C28.1056 6.95388 23.8953 6.95382 21.367 4.44798L20.2231 5.60215ZM39.7425 10.1703L38.1703 9.75916C36.844 14.8314 40.0502 20.0785 45.102 21.432L45.5225 19.8624L45.943 18.2927C42.5432 17.3818 40.4597 13.8507 41.3146 10.5814L39.7425 10.1703ZM17.0645 4.9736L17.8629 6.38897C18.0685 6.27297 18.2301 6.18189 18.3703 6.10632C18.5112 6.03042 18.6034 5.98501 18.6667 5.95736C18.8069 5.89621 18.672 5.98395 18.4207 5.9503L18.6362 4.33966L18.8518 2.72903C18.2385 2.64694 17.721 2.82418 17.3674 2.97838C17.0261 3.12724 16.6388 3.34805 16.2662 3.55823L17.0645 4.9736ZM20.2231 5.60215L21.367 4.44798C20.9803 4.06473 20.6163 3.70196 20.3011 3.43859C20.0148 3.19934 19.5191 2.81833 18.8518 2.72903L18.6362 4.33966L18.4207 5.9503C18.2523 5.92777 18.1477 5.87244 18.1247 5.85951C18.1066 5.84932 18.1321 5.86143 18.2172 5.93253C18.4008 6.08596 18.6493 6.33021 19.0792 6.75632L20.2231 5.60215ZM13.3277 7.0814L12.5293 5.66603C12.1491 5.88052 11.7542 6.10093 11.447 6.31812C11.1318 6.541 10.7031 6.89749 10.4566 7.47646L11.9517 8.11307L13.4468 8.74968C13.3435 8.99233 13.1919 9.06477 13.3234 8.97178C13.3817 8.93056 13.4706 8.87371 13.6114 8.79068C13.7516 8.70804 13.9166 8.61492 14.126 8.49677L13.3277 7.0814ZM12.2582 10.1701L13.8304 9.75919C13.6729 9.15634 13.5825 8.80505 13.5399 8.55973C13.52 8.44518 13.5222 8.41447 13.5219 8.43417C13.5216 8.45865 13.5175 8.58369 13.4468 8.74968L11.9517 8.11307L10.4566 7.47646C10.1868 8.11008 10.2741 8.7485 10.3378 9.11533C10.4093 9.52765 10.5438 10.0367 10.686 10.581L12.2582 10.1701ZM13.3242 41.6684L14.1226 40.253C13.9131 40.1349 13.7481 40.0418 13.608 39.9591C13.4671 39.8761 13.3782 39.8192 13.3199 39.778C13.1884 39.685 13.3401 39.7575 13.4434 40.0001L11.9482 40.6367L10.4531 41.2732C10.6996 41.8522 11.1283 42.2087 11.4435 42.4316C11.7507 42.6489 12.1456 42.8693 12.5259 43.0838L13.3242 41.6684ZM12.2549 38.5798L10.6828 38.1687C10.5405 38.7129 10.4059 39.2219 10.3343 39.6343C10.2707 40.0011 10.1833 40.6395 10.4531 41.2732L11.9482 40.6367L13.4434 40.0001C13.514 40.1661 13.5182 40.2912 13.5184 40.3157C13.5187 40.3354 13.5166 40.3047 13.5364 40.1902C13.579 39.9449 13.6694 39.5937 13.8271 38.9909L12.2549 38.5798ZM17.0611 43.7762L16.2627 45.1916C16.6354 45.4018 17.0228 45.6226 17.3641 45.7715C17.7177 45.9257 18.2352 46.1029 18.8486 46.0208L18.6329 44.4102L18.4172 42.7995C18.6686 42.7659 18.8035 42.8536 18.6634 42.7925C18.6 42.7648 18.5078 42.7194 18.367 42.6435C18.2267 42.5679 18.0651 42.4769 17.8594 42.3609L17.0611 43.7762ZM20.2196 43.1476L19.0755 41.9936C18.6457 42.4197 18.3973 42.664 18.2137 42.8174C18.1286 42.8885 18.1032 42.9006 18.1213 42.8904C18.1443 42.8774 18.2489 42.8221 18.4172 42.7995L18.6329 44.4102L18.8486 46.0208C19.5159 45.9314 20.0116 45.5504 20.2979 45.3111C20.6131 45.0477 20.977 44.6849 21.3636 44.3016L20.2196 43.1476ZM38.6731 7.08161L37.8748 8.49697C38.0843 8.61513 38.2493 8.70826 38.3894 8.7909C38.5302 8.87393 38.6192 8.93078 38.6775 8.97201C38.809 9.06499 38.6573 8.99254 38.554 8.74988L40.0492 8.11336L41.5443 7.47684C41.2978 6.89781 40.8691 6.54128 40.5538 6.31838C40.2467 6.10116 39.8518 5.88073 39.4715 5.66624L38.6731 7.08161ZM39.7425 10.1703L41.3146 10.5814C41.4569 10.0371 41.5915 9.5281 41.663 9.11578C41.7267 8.74891 41.8141 8.1105 41.5443 7.47684L40.0492 8.11336L38.554 8.74988C38.4834 8.58391 38.4792 8.45887 38.479 8.43435C38.4787 8.41463 38.4808 8.44533 38.4609 8.55985C38.4184 8.80513 38.328 9.15636 38.1703 9.75916L39.7425 10.1703ZM34.9363 4.97381L35.7347 3.55844C35.362 3.34826 34.9747 3.12745 34.6334 2.97859C34.2799 2.82439 33.7624 2.64715 33.1491 2.72923L33.3646 4.33987L33.5802 5.95051C33.3288 5.98415 33.1939 5.89642 33.3341 5.95757C33.3975 5.98522 33.4896 6.03063 33.6305 6.10653C33.7707 6.1821 33.9323 6.27318 34.138 6.38917L34.9363 4.97381ZM31.7777 5.60235L32.9216 6.75653C33.3516 6.33042 33.6 6.08617 33.7836 5.93275C33.8687 5.86165 33.8942 5.84953 33.8761 5.85972C33.8531 5.87265 33.7485 5.92798 33.5802 5.95051L33.3646 4.33987L33.1491 2.72923C32.4818 2.81854 31.986 3.19954 31.6997 3.43878C31.3845 3.70215 31.0205 4.06491 30.6338 4.44816L31.7777 5.60235ZM4.33203 22.2939H5.95703C5.95703 22.0563 5.95709 21.8697 5.96021 21.7095C5.96335 21.5485 5.96915 21.4456 5.97628 21.3769C5.99215 21.224 6.00207 21.3914 5.84222 21.5987L4.55538 20.6064L3.26854 19.6141C2.88535 20.111 2.78359 20.6563 2.74362 21.0417C2.70496 21.4144 2.70703 21.8636 2.70703 22.2939H4.33203ZM6.47491 19.8624L6.05444 18.2927C5.51831 18.4363 5.01458 18.5698 4.62397 18.7106C4.27305 18.837 3.68428 19.0749 3.26854 19.6141L4.55538 20.6064L5.84222 21.5987C5.73535 21.7373 5.63193 21.801 5.61047 21.8135C5.59343 21.8235 5.6184 21.8068 5.72575 21.7681C5.95638 21.685 6.30073 21.5913 6.89538 21.4321L6.47491 19.8624ZM4.33203 26.4561H2.70703C2.70703 26.8864 2.70496 27.3356 2.74362 27.7083C2.78359 28.0937 2.88533 28.6389 3.2685 29.1359L4.55536 28.1436L5.84223 27.1513C6.00206 27.3586 5.99214 27.526 5.97628 27.3731C5.96915 27.3044 5.96335 27.2015 5.96021 27.0405C5.95709 26.8804 5.95703 26.6937 5.95703 26.4561H4.33203ZM6.4749 28.8877L6.89545 27.318C6.3008 27.1587 5.95643 27.065 5.7258 26.9819C5.61843 26.9432 5.59346 26.9265 5.6105 26.9365C5.63194 26.949 5.73536 27.0127 5.84223 27.1513L4.55536 28.1436L3.2685 29.1359C3.68421 29.675 4.27296 29.9129 4.62387 30.0394C5.01447 30.1802 5.51821 30.3137 6.05436 30.4573L6.4749 28.8877ZM47.6654 22.2939H49.2904C49.2904 21.8636 49.2924 21.4144 49.2538 21.0417C49.2138 20.6563 49.1121 20.1111 48.7289 19.6142L47.442 20.6064L46.1552 21.5987C45.9953 21.3914 46.0053 21.224 46.0211 21.377C46.0282 21.4457 46.034 21.5485 46.0372 21.7095C46.0403 21.8697 46.0404 22.0563 46.0404 22.2939H47.6654ZM45.5225 19.8624L45.102 21.432C45.6966 21.5913 46.041 21.685 46.2716 21.7681C46.379 21.8068 46.4039 21.8235 46.3869 21.8135C46.3655 21.801 46.262 21.7373 46.1552 21.5987L47.442 20.6064L48.7289 19.6142C48.3132 19.075 47.7244 18.8371 47.3735 18.7107C46.9829 18.5699 46.4792 18.4364 45.943 18.2927L45.5225 19.8624ZM47.6654 22.2939H46.0404V22.7705H47.6654H49.2904V22.2939H47.6654ZM20.2196 43.1476L21.3636 44.3016C21.5014 44.165 21.644 44.0359 21.7909 43.9144L20.7551 42.6624L19.7192 41.4103C19.4976 41.5936 19.2828 41.7881 19.0755 41.9935L20.2196 43.1476Z"
        fill="#D4CFFF"
      />
      <path
        d="M36.8333 32.5V36.8333M36.8528 41.1667H36.8333M47.6667 36.8333C47.6667 42.8164 42.8164 47.6667 36.8333 47.6667C30.8502 47.6667 26 42.8164 26 36.8333C26 30.8502 30.8502 26 36.8333 26C42.8164 26 47.6667 30.8502 47.6667 36.8333Z"
        fill="none"
        stroke="#D4CFFF"
        strokeWidth="3.25"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
};

export const AutojoinLabelIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 63 63" fill="none">
      <circle cx="31.5" cy="31.5" r="31.5" fill="#3A325D" />
      <path
        d="M32.1759 23.2388L25.9289 32.3768C25.4481 33.0801 24.7836 33.5704 23.9655 33.8263C23.43 33.9939 23.1623 34.0776 22.9588 34.166C20.4319 35.264 20.0376 37.9933 21.2832 40.1508L21.9668 41.3348C23.2124 43.4923 25.7732 44.5154 27.9875 42.8761C28.1658 42.7441 28.3723 42.5541 28.7851 42.1741C29.4158 41.5936 30.1727 41.2632 31.0221 41.1985L42.0594 40.3574C44.5931 40.1643 45.8599 40.0678 46.7516 39.0581C47.6432 38.0485 47.563 37.033 47.4027 35.0019C46.9622 29.4245 44.0955 24.4592 39.4856 21.2891C37.8068 20.1347 36.9674 19.5575 35.6472 19.8249C34.327 20.0922 33.61 21.1411 32.1759 23.2388Z"
        fill="currentColor"
      />
      <path
        d="M29.1095 19.9468L22.8625 29.0848C22.3817 29.7881 21.7172 30.2784 20.899 30.5343C20.3636 30.7019 20.0959 30.7856 19.8924 30.874C17.3655 31.972 16.9712 34.7013 18.2168 36.8588L18.9004 38.0428C20.146 40.2003 22.7068 41.2234 24.9211 39.5841C25.0994 39.4521 25.3059 39.2621 25.7186 38.8821C26.3494 38.3016 27.1063 37.9712 27.9557 37.9065L38.993 37.0654C41.5267 36.8724 42.7935 36.7758 43.6852 35.7662C44.5768 34.7565 44.4966 33.741 44.3362 31.7099C43.8958 26.1326 41.0291 21.1672 36.4192 17.9971C34.7404 16.8427 33.901 16.2655 32.5808 16.5329C31.2606 16.8002 30.5436 17.8491 29.1095 19.9468Z"
        fill="none"
        stroke="#FA2A75"
        strokeWidth="2.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.4838 45.1662L34.7177 45.4354C36.63 45.6658 37.5861 45.781 38.1661 45.5124C38.9395 45.1543 39.4441 44.39 39.4697 43.5381C39.4888 42.8992 39.0073 42.0652 38.0442 40.3971L37.6692 39.7476L28 41L29.125 42.9486C30.0414 44.5358 30.6643 44.947 32.4838 45.1662Z"
        fill="currentColor"
      />
      <path
        d="M36.0491 37.7452L36.4241 38.3947C37.3872 40.0627 37.8687 40.8968 37.8495 41.5357C37.824 42.3875 37.3194 43.1518 36.546 43.5099C35.966 43.7785 35.0099 43.6633 33.0976 43.4329L30.8637 43.1638C29.0441 42.9446 28.4213 42.5333 27.5049 40.9461L26.3799 38.9976"
        fill="none"
        stroke="#FA2A75"
        strokeWidth="2.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.6543 37.9729L22.1543 30.1787"
        fill="none"
        stroke="#FA2A75"
        strokeWidth="2.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g opacity="0.8">
        <path
          d="M24.4045 10.4146L14.8782 15.9146C11.6624 17.7712 10.5915 21.4899 12.499 24.7937"
          fill="none"
          stroke="#FA2A75"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.4229 9.2495C21.4229 9.2495 24.5085 9.59406 24.8379 10.1646C25.1673 10.7351 23.9229 13.5796 23.9229 13.5796"
          fill="none"
          stroke="#FA2A75"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <g opacity="0.8">
        <path
          d="M39.6815 53.3794L49.2077 47.8794C52.4235 46.0228 53.4944 42.3041 51.5869 39.0002"
          fill="none"
          stroke="#FA2A75"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M40.1631 50.2144C40.1631 50.2144 38.9187 53.0589 39.2481 53.6294C39.5775 54.2 42.6631 54.5445 42.6631 54.5445"
          fill="none"
          stroke="#FA2A75"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
};

export const LightningIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 16 16" fill="none">
      <path
        d="M8 16C3.58172 16 4.10854e-07 12.4183 6.03983e-07 8C7.97112e-07 3.58172 3.58172 -5.4282e-07 8 -3.49691e-07C12.4183 -1.56562e-07 16 3.58172 16 8C16 12.4183 12.4183 16 8 16Z"
        fill="currentColor"
      />
      <path
        d="M8.66047 4L6.63297 7.06718C6.36154 7.4778 6.22582 7.68311 6.3099 7.84156C6.39398 8 6.63865 8 7.12798 8H8.8709C9.36024 8 9.6049 8 9.68898 8.15844C9.77306 8.31689 9.63734 8.5222 9.36591 8.93282L7.33841 12"
        stroke="white"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const LinkOffIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24" fill="none">
      <path
        d="M9 17H7C5.67392 17 4.40215 16.4732 3.46447 15.5355C2.52678 14.5979 2 13.3261 2 12C2 10.6739 2.52678 9.40215 3.46447 8.46447C4.40215 7.52678 5.67392 7 7 7M15 7H17C17.9286 7 18.8388 7.25857 19.6287 7.74675C20.4185 8.23492 21.0569 8.9334 21.4721 9.76393C21.8874 10.5945 22.0632 11.5242 21.9798 12.449C21.8964 13.3738 21.5571 14.2572 21 15M8 12H12M2 2L22 22"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const LinkOnIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24" fill="none">
      <path
        d="M6.33962 13.4146L4.9254 12.0004C3.98772 11.0627 3.46094 9.79093 3.46094 8.46484C3.46094 7.13876 3.98772 5.86699 4.9254 4.92931C5.86309 3.99163 7.13486 3.46484 8.46094 3.46484C9.78702 3.46484 11.0588 3.99163 11.9965 4.92931L13.4107 6.34352M17.6533 10.5862L19.0675 12.0004C20.0052 12.9381 20.532 14.2098 20.532 15.5359C20.532 16.862 20.0052 18.1338 19.0675 19.0714C18.1299 20.0091 16.8581 20.5359 15.532 20.5359C14.2059 20.5359 12.9342 20.0091 11.9965 19.0714L10.5823 17.6572M9.16804 9.17195L14.8249 14.8288"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const TrashIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 16 16" fill="none">
      <path
        fill="none"
        d="M13 3.6665L12.5868 10.3499C12.4813 12.0575 12.4285 12.9113 12.0005 13.5251C11.7889 13.8286 11.5164 14.0847 11.2005 14.2772C10.5614 14.6665 9.70599 14.6665 7.99516 14.6665C6.28208 14.6665 5.42554 14.6665 4.78604 14.2765C4.46987 14.0836 4.19733 13.827 3.98579 13.5231C3.55792 12.9082 3.5063 12.0532 3.40307 10.3433L3 3.6665"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        fill="none"
        d="M6 7.82324H10"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        fill="none"
        d="M7 10.436H9"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        fill="none"
        d="M2 3.66659H14M10.7037 3.66659L10.2486 2.72774C9.94626 2.10409 9.7951 1.79227 9.53435 1.59779C9.47651 1.55465 9.41527 1.51628 9.35122 1.48305C9.06248 1.33325 8.71595 1.33325 8.02289 1.33325C7.31243 1.33325 6.95719 1.33325 6.66366 1.48933C6.59861 1.52392 6.53653 1.56385 6.47807 1.6087C6.2143 1.81105 6.06696 2.13429 5.77228 2.78076L5.36849 3.66659"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
};

export const DashboardSquareEditIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20" fill="none">
      <path
        d="M1.66602 5.00008C1.66602 3.83331 1.66602 3.24992 1.89309 2.80427C2.09282 2.41226 2.41153 2.09355 2.80354 1.89382C3.24918 1.66675 3.83257 1.66675 4.99935 1.66675C6.16612 1.66675 6.74951 1.66675 7.19516 1.89382C7.58717 2.09355 7.90588 2.41226 8.10561 2.80427C8.33268 3.24992 8.33268 3.83331 8.33268 5.00008C8.33268 6.16686 8.33268 6.75025 8.10561 7.19589C7.90588 7.5879 7.58717 7.90661 7.19516 8.10634C6.74951 8.33341 6.16612 8.33341 4.99935 8.33341C3.83257 8.33341 3.24918 8.33341 2.80354 8.10634C2.41153 7.90661 2.09282 7.5879 1.89309 7.19589C1.66602 6.75025 1.66602 6.16686 1.66602 5.00008Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.25"
      />
      <path
        d="M1.66602 15.0001C1.66602 13.8333 1.66602 13.2499 1.89309 12.8043C2.09282 12.4123 2.41153 12.0936 2.80354 11.8938C3.24918 11.6667 3.83257 11.6667 4.99935 11.6667C6.16612 11.6667 6.74951 11.6667 7.19516 11.8938C7.58717 12.0936 7.90588 12.4123 8.10561 12.8043C8.33268 13.2499 8.33268 13.8333 8.33268 15.0001C8.33268 16.1669 8.33268 16.7502 8.10561 17.1959C7.90588 17.5879 7.58717 17.9066 7.19516 18.1063C6.74951 18.3334 6.16612 18.3334 4.99935 18.3334C3.83257 18.3334 3.24918 18.3334 2.80354 18.1063C2.41153 17.9066 2.09282 17.5879 1.89309 17.1959C1.66602 16.7502 1.66602 16.1669 1.66602 15.0001Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.25"
      />
      <path
        d="M11.666 15.0001C11.666 13.8333 11.666 13.2499 11.8931 12.8043C12.0928 12.4123 12.4115 12.0936 12.8035 11.8938C13.2492 11.6667 13.8326 11.6667 14.9993 11.6667C16.1661 11.6667 16.7495 11.6667 17.1952 11.8938C17.5872 12.0936 17.9059 12.4123 18.1056 12.8043C18.3327 13.2499 18.3327 13.8333 18.3327 15.0001C18.3327 16.1669 18.3327 16.7502 18.1056 17.1959C17.9059 17.5879 17.5872 17.9066 17.1952 18.1063C16.7495 18.3334 16.1661 18.3334 14.9993 18.3334C13.8326 18.3334 13.2492 18.3334 12.8035 18.1063C12.4115 17.9066 12.0928 17.5879 11.8931 17.1959C11.666 16.7502 11.666 16.1669 11.666 15.0001Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.25"
      />
      <path
        d="M12.7891 8.21318L12.6584 7.602H12.6584L12.7891 8.21318ZM11.7862 7.21032L12.3974 7.341V7.341L11.7862 7.21032ZM12.5166 5.09318L12.0746 4.65124H12.0746L12.5166 5.09318ZM14.9063 7.48285L15.3482 7.9248V7.9248L14.9063 7.48285ZM18.1629 2.89783L18.7042 2.58533V2.58533L18.1629 2.89783ZM17.6628 4.72632L17.2208 4.28438V4.28438L17.6628 4.72632ZM18.1629 4.16514L18.7042 4.47764V4.47764L18.1629 4.16514ZM17.1016 1.83654L17.4141 1.29527V1.29527L17.1016 1.83654ZM15.2731 2.33665L15.715 2.77859V2.77859L15.2731 2.33665ZM15.8343 1.83654L15.5218 1.29527V1.29527L15.8343 1.83654ZM17.6628 4.72632L17.2208 4.28438L14.4643 7.04091L14.9063 7.48285L15.3482 7.9248L18.1047 5.16826L17.6628 4.72632ZM12.5166 5.09318L12.9585 5.53512L15.715 2.77859L15.2731 2.33665L14.8312 1.8947L12.0746 4.65124L12.5166 5.09318ZM12.7891 8.21318L12.6584 7.602C12.5122 7.63326 12.3954 7.65819 12.295 7.67685C12.1937 7.69568 12.1273 7.70458 12.0823 7.70745C12.0361 7.71039 12.0393 7.70491 12.0681 7.71234C12.1074 7.72246 12.1607 7.74774 12.2062 7.79323L11.7643 8.23517L11.3223 8.67711C11.5921 8.94693 11.9292 8.96971 12.1617 8.95493C12.3829 8.94086 12.6526 8.8815 12.9198 8.82436L12.7891 8.21318ZM11.7862 7.21032L11.1751 7.07963C11.1179 7.34683 11.0586 7.61653 11.0445 7.83778C11.0297 8.07024 11.0525 8.40729 11.3223 8.67711L11.7643 8.23517L12.2062 7.79323C12.2517 7.83872 12.277 7.89207 12.2871 7.9313C12.2945 7.96014 12.289 7.96334 12.292 7.91711C12.2948 7.87209 12.3037 7.8057 12.3226 7.7044C12.3412 7.60402 12.3662 7.48721 12.3974 7.341L11.7862 7.21032ZM17.6628 2.33665L17.2208 2.77859C17.5271 3.08483 17.5897 3.15506 17.6216 3.21033L18.1629 2.89783L18.7042 2.58533C18.5692 2.35161 18.3541 2.14404 18.1047 1.8947L17.6628 2.33665ZM17.6628 4.72632L18.1047 5.16826C18.3541 4.91893 18.5692 4.71136 18.7042 4.47764L18.1629 4.16514L17.6216 3.85264C17.5897 3.90791 17.5271 3.97814 17.2208 4.28438L17.6628 4.72632ZM18.1629 2.89783L17.6216 3.21033C17.7364 3.40906 17.7364 3.65391 17.6216 3.85264L18.1629 4.16514L18.7042 4.47764C19.0422 3.89216 19.0422 3.17081 18.7042 2.58533L18.1629 2.89783ZM17.6628 2.33665L18.1047 1.8947C17.8554 1.64537 17.6478 1.43021 17.4141 1.29527L17.1016 1.83654L16.7891 2.3778C16.8444 2.40971 16.9146 2.47234 17.2208 2.77859L17.6628 2.33665ZM15.2731 2.33665L15.715 2.77859C16.0213 2.47234 16.0915 2.40971 16.1468 2.3778L15.8343 1.83654L15.5218 1.29527C15.2881 1.43021 15.0805 1.64537 14.8312 1.8947L15.2731 2.33665ZM17.1016 1.83654L17.4141 1.29527C16.8286 0.957241 16.1073 0.957241 15.5218 1.29527L15.8343 1.83654L16.1468 2.3778C16.3455 2.26306 16.5904 2.26306 16.7891 2.3778L17.1016 1.83654ZM14.9063 7.48285L14.4643 7.04091C14.3014 7.20386 14.0787 7.30921 13.7623 7.39C13.6038 7.43047 13.4347 7.46175 13.2463 7.49431C13.0652 7.52559 12.8579 7.55934 12.6584 7.602L12.7891 8.21318L12.9198 8.82437C13.088 8.78841 13.2603 8.7604 13.4591 8.72606C13.6505 8.69299 13.8615 8.65477 14.0715 8.60115C14.4922 8.49375 14.9604 8.31256 15.3482 7.9248L14.9063 7.48285ZM11.7862 7.21032L12.3974 7.341C12.4401 7.14153 12.4738 6.93422 12.5051 6.75317C12.5377 6.56472 12.569 6.39565 12.6094 6.23714C12.6902 5.92072 12.7956 5.69806 12.9585 5.53512L12.5166 5.09318L12.0746 4.65124C11.6869 5.039 11.5057 5.50727 11.3983 5.92792C11.3447 6.13795 11.3064 6.34894 11.2734 6.54035C11.239 6.73914 11.211 6.91146 11.1751 7.07963L11.7862 7.21032Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
